import { Circle, Square } from "lucide-react"

/** Record affordance: filled circle (idle) / square (recording) — same as timeline audio compose. */
export function MediaRecordGlyph({ recording }: { recording: boolean }) {
  return recording ? (
    <Square className="h-2.5 w-2.5 fill-current" aria-hidden />
  ) : (
    <Circle className="h-2.5 w-2.5 fill-current" aria-hidden />
  )
}
